const benefits = [
  {
    icon: 'ri-trophy-line',
    title: 'Increase Bookings Without Hiring',
    description: 'Close more deals with the same team. Trewaz automates the repetitive work so your staff focuses on high-value conversations.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Respond Instantly to Every Lead',
    description: 'The first agency to respond wins the booking. Trewaz replies within seconds — even at 3am on a Friday.',
  },
  {
    icon: 'ri-time-line',
    title: 'Save Hours Every Day',
    description: 'Stop copy-pasting WhatsApp messages, manually entering leads, and chasing follow-ups. Get back 2–3 hours daily.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Never Miss an Enquiry',
    description: 'All enquiries from every channel are captured automatically. Nothing falls through the cracks — ever.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Full Visibility on Your Pipeline',
    description: 'See every lead, every stage, every deal in one clean dashboard. Make decisions based on real data, not guesswork.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Built for Travel, Not Generic',
    description: 'Trewaz was designed specifically for travel agencies — not adapted from generic CRM tools. It fits how you actually work.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left sticky label */}
          <div className="w-full lg:w-80 shrink-0">
            <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">Why Trewaz</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight">
              Why Travel Agencies<br />
              <span className="bg-gradient-to-r from-teal-400 to-indigo-400 bg-clip-text text-transparent">Use TreWaz</span>
            </h2>
            <p className="text-sm text-gray-500 mt-4 leading-relaxed">
              Built from the ground up for independent and mid-size travel agencies that want to scale without scaling their headcount.
            </p>
          </div>

          {/* Right grid */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div key={benefit.title} className="flex gap-4">
                <div className={`w-9 h-9 flex items-center justify-center shrink-0 mt-0.5 rounded-lg ${
                  index % 3 === 0 ? 'bg-teal-50' : index % 3 === 1 ? 'bg-indigo-50' : 'bg-teal-50'
                }`}>
                  <i className={`${benefit.icon} text-lg ${
                    index % 3 === 0 ? 'text-teal-500' : index % 3 === 1 ? 'text-indigo-500' : 'text-teal-600'
                  }`} />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
